// extracted by mini-css-extract-plugin
export default {"CarouselScrollRightButton":"CarouselScrollRightButton_CarouselScrollRightButton__f7iF9","arrowImage":"CarouselScrollRightButton_arrowImage__hKC9+"};